<div class="ngx-data-table">
  <data-table-header [rowIdProp]="rowIdProp"
    [isLoading]="isLoading"
    [columns]="columns"
    [currentSort]="currentSort"
    [rows]="rows"
    [showCheckboxes]="false"
    [canSelectAll]="false"
    [useFullMobileTable]="true"
    [isMobile] = "true"
    (onSortChange)="onSortChange.emit($event)">
  </data-table-header>

  <!--Data table body-->
  @if (!isDataAvailable() && !isLoading) {
    <div class="flex-container"
      fxLayout="row"
      fxLayoutAlign="start center"
      >
      <data-table-error [errorText]="noResultsMessage"
        [actionableText]="actionableErrorText"
        (textClick)="errorTextClicked()">
      </data-table-error>
    </div>
  }
  @if (isLoading) {
    <mat-spinner
      class="mobile-data-table-full__spinner"
      >
    </mat-spinner>
  }
  @if (isDataAvailable()) {
    <div>
      @for (row of rows; track trackRow($index, row); let i = $index) {
        <div class="flex-container mobile-data-table-full__row"
         [ngClass]="{'ngx-data-table__row-bottom-border' : row.bottomBorder,
                     'ngx-data-table__blue-row-background' : (i % 2  !== 0),
                     'mobile-data-table-full__large-row': !useSmallRowSize }"
          fxLayout="row wrap"
          [id]="row[rowId]">
          <div fxLayout="row" fxFlex="100">
            <div class="flex-item" fxFlex="25px"></div>
            @for (col of columns; track trackColumn($index, col)) {
              <div [fxFlex]="getColSize(col)">
                @if (!col.hide) {
<span [ngClass]="{
          'ngx-data-table__row-disabled': shouldDisableRow(row),
          'ngx-data-table__center-column': col.centerContent}"
                    class="flex-item"
                    (click)="rowClicked(row)"
                    (keydown.enter)="$event.target === $event.currentTarget && (rowClicked(row))">
                    <data-table-cell class="mobile-data-table-full__data-cell"
                      [row]="row"
                      [col]="col"
                      [shouldDisableButton]= "shouldDisableRow(row)"
                      [useFullMobileTable]="true">
                    </data-table-cell>
                  </span>
                }
              </div>
            }
            @if (isDetailView && !row.open) {
              <div fxLayout="row" fxLayoutAlign="center center" fxFlex="10">
                <button
                  type="button"
                  class="ngx-data-table__chevron-button"
                  aria-expanded="false"
                  (click)="openDetail(row)">
                  <img alt="Chevron Icon Facing Down"
                    class="mobile-data-table-full__chevron-icon-down"
                    src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
                </button>
              </div>
            }
            @if (isDetailView && row.open) {
              <div fxLayout="row" fxLayoutAlign="center center" fxFlex="10">
                <button
                  type="button"
                  class="ngx-data-table__chevron-button"
                  aria-expanded="true"
                  (click)="openDetail(row)">
                  <img alt="Chevron Icon Facing Up"
                    class="mobile-data-table-full__chevron-icon-up"
                    src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
                </button>
              </div>
            }
            @if (!shouldHideChevron(row)) {
              <button
                type="button"
                fxFlex="32px"
                class="ngx-data-table__chevron-button"
                (click)="rowClicked(row)">
                <img alt="Chevron Icon"
                  class="ngx-data-table__chevron-icon"
                  src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
              </button>
            }
            <div class="flex-item" fxFlex="25px"></div>
          </div>
          @if (isDetailView && row.open) {
            <div
              class="mobile-data-table-full__detail-table"
              [ngClass]="{'ngx-data-table__blue-row-background' : (i % 2  !== 0)}"
              fxLayout="row wrap">
              @for (detRowCol of detailColumns; track trackColumn($index, detRowCol)) {
                <div [fxFlex]="getColSize(detRowCol)">
                  {{detRowCol.title}}
                </div>
              }
              @for (detRow of row[detailProp]; track trackDetailRow($index, detRow)) {
                <div fxLayout="row"
                  fxFlex="100"
                  >
                  @for (detCol of detailColumns; track trackColumn($index, detCol)) {
                    <div [fxFlex]="getColSize(detCol)">
                      <data-table-cell [row]="detRow"
                        [col]="detCol"
                        [useFullMobileTable]="true">
                      </data-table-cell>
                    </div>
                  }
                </div>
              }
              @if (row.doorDash) {
                <div
                  class="ngx-data-table__mobile-notes">
                  {{detailViewNoteText}}
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  @if (showFooter) {
    <data-table-footer
      [totalElements]="totalElements"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      [numberOfPages]="numberOfPages"
      [isMobile]="isMobile"
      (onPageChange)="pageChange($event)">
    </data-table-footer>
  }
</div>
